import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { Divider } from '../../../components/Divider';

interface Props {
  className?: string;
  header: string;
  description: string;
  icon?: ReactNode;
}

export const SettingSectionHeader = ({
  className,
  header,
  description,
  icon = null,
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Divider />
      <div className={clsx(className, classes.sectionText)}>
        <h4 className={classes.header}>
          {icon}
          {header}
        </h4>
        <p className={classes.description}>{description}</p>
      </div>
      <Divider />
    </div>
  );
};

const useStyles = () => ({
  container:
    'w-full sticky top-[69px] z-10 bg-background-light dark:bg-background-dark',
  description: 'text-xs opacity-70',
  header: 'inline-flex items-center gap-2 text-lg',
  sectionText: 'relative block px-2 py-4',
});
